/**/
$(document).ready(function (){

    /*Слайдер с 1 слайдом в десктопе, 4 слайдами в таблетке, 2 слайдами в мобилке*/
    $('.sliderOneProduct.all-front-works').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        infinite: true,
        variableWidth: true,
        responsive: [
            {
                breakpoint: 769,
                settings: {
                    arrows: false,
                    dots: true,
                    slidesToShow: 4,
                }
            }
        ]
    });
});
